import { render, staticRenderFns } from "./HeaderMenuLeft.vue?vue&type=template&id=381b44ac&scoped=true&"
import script from "./HeaderMenuLeft.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuLeft.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuLeft.vue?vue&type=style&index=0&id=381b44ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b44ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMenuLeftDropdown: require('/var/www/app/components/HeaderMenuLeftDropdown.vue').default})
